import { fetchJobStatus } from "./jobClient.js";
import { removeJob, updateJob } from "./storage.js";

export function pollJob({
  jobId,
  statusUrl,
  interval = 3000,
  timeout = 5 * 60 * 1000,
  onUpdate,
  onComplete,
  onError,
}) {
  let elapsed = 0;

  const timer = setInterval(async () => {
    try {
      elapsed += interval;

      if (elapsed > timeout) {
        clearInterval(timer);
        updateJob(jobId, { status: "timeout" });
        onError?.("Polling timeout");
        return;
      }

      const data = await fetchJobStatus(statusUrl);

      updateJob(jobId, data);
      onUpdate?.(data);

      if (data.success === true && data.result) {
        clearInterval(timer);
        removeJob(jobId);
        onComplete?.(data.result);
      }

      if (data.status === "failed") {
        clearInterval(timer);
        removeJob(jobId);
        onError?.(data.error || "Job failed");
      }
    } catch (err) {
      clearInterval(timer);
      onError?.(err.message);
    }
  }, interval);

  return () => clearInterval(timer);
}
